<template>
  <!-- 零售详情-修改预计发货时间 -->
  <div class="cus-modal"
       v-loading="loading">
    <OmsForm :form-config="formConfig" />
    <OmsButton :class="['modal-footer']"
               :btn-config="btnConfig" />
  </div>
</template>

<script>
export default {
  components: {},
  name: 'updateEstimateConTime',
  props: ['componentData'],
  data() {
    return {
      loading: false,
      formConfig: {
        formValue: {
          estimateConTime: '',
        },
        formData: [
          {
            style: 'date',
            type: 'datetime', // 日期组件类型,默认为data  (daterange)为双日期区间选择
            value: 'estimateConTime',
            label: t('预计发货时间'),
            width: '24',
            format: 'yyyy-MM-dd HH:mm:ss', // 格式参照burgeonui
            placeholder: t('请选择'),
            /* options: {
              disabledDate(date) {
                return date && date.valueOf() < Date.now();
              }
            } */
          },
        ],
        ruleValidate: {
          estimateConTime: [{ required: true, message: ' ', trigger: 'blur' }]
        }
      },
      btnConfig: {
        typeAll: 'default',
        btnsite: 'right',
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }
          },
          {
            type: 'primary', // 按钮类型
            text: t('确定'),
            btnclick: () => {
              this.confirmChange();
            }
          }
        ]
      }
    };
  },
  computed: {
    orderId() {
      return this.componentData.ID
    },
    oldSendTime() {
      return this.componentData.ESTIMATE_CON_TIME
    }
  },
  methods: {
    // 确定请求
    async confirmInfo(data) {
      this.loading = true;
      try {
        const res = await this.service.orderCenter.updateEstimateConTime(data);
        if (res.data.code === 0) {
          this.$Message.success(res.data.message);
          this.$parent.$parent.closeConfirm();
          this.$nextTick(() => {
            this.$parent.$parent.$parent.load();
          });
        } else {
          $fcError(res.data.message);
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }

    },
    confirmChange() {
      const time = this.formConfig.formValue.estimateConTime
      if (!time) {
        $fcError(t('预计发货时间不能为空！'))
        return
      } else if (time.valueOf() < Date.now()) {
        $fcError(t('预计发货时间不能小于当前时间！'))
        return
      }
      const param = {
        orderId: this.orderId,
        estimateConTime: $utils.dateFormat(time, 'yyyy-MM-dd hh:mm:ss'),
      }
      this.confirmInfo(param)
    }
  },
  mounted() {
    if (this.oldSendTime) {
      this.formConfig.formValue.estimateConTime = new Date(this.oldSendTime)
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/css/modal/orderCenter/holdOrderDialog.less';
</style>
